import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import { userService } from './service';
import store from '@/store/index'; // 查询字段列表-高级列配置

export function LoadListFields(data) {
  return userService.post('ListParam/LoadListFields', _objectSpread(_objectSpread({}, data), {}, {
    LIST_ROUTE: store.getters.routerPath
  }));
} // 查询数据-高级配置

export function LoadData() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return userService.post('ListParam/LoadData', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, query)); // return userService.post(`ListParam/LoadData`, { LIST_ROUTE: "/ImsBillMst/Index/WI?code=WI", ...query})
} // 获取参数下拉选择框

export function GetSelectList(data) {
  return userService.post('ListParam/GetSelectList', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, data)); // return userService.post(`ListParam/GetSelectList`, {LIST_ROUTE: "/ImsBillMst/Index/WI?code=WI",...data})
} // 查询数据-高级查询

export function LoadListAdvancedQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return userService.post('ListParam/LoadListAdvancedQuery', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, query)); // return userService.post(`ListParam/LoadListAdvancedQuery`, {LIST_ROUTE:"/ImsBillMst/Index/WI?code=WI",...query})
} // 查询字段列表-高级列配置

export function SaveListFields(data) {
  data && data.map(function (item) {
    item.LIST_ROUTE = store.getters.routerPath; // item.LIST_ROUTE = "/ImsBillMst/Index/WI?code=WI"
  });
  return userService.post('ListParam/SaveListFields', data);
} // 保存数据-高级配置

export function SaveData(data) {
  data && data.map(function (item) {
    item.LIST_ROUTE = store.getters.routerPath;
  });
  return userService.post('ListParam/SaveData', data);
} // 高级配置-删除单个

export function DeleteOne(data) {
  return userService.post('ListParam/DeleteOne', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, data));
} // 高级配置-删除所有

export function DeleteAllParams(data) {
  return userService.post('ListParam/DeleteAllParams', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, data));
} // 高级列配置-删除所有

export function DeleteFields(data) {
  return userService.post('ListParam/DeleteFields', _objectSpread({
    LIST_ROUTE: store.getters.routerPath
  }, data));
} // 保存数据-高级查询

export function SaveListAdvancedQuery(data) {
  data && data.map(function (item) {
    item.LIST_ROUTE = store.getters.routerPath;
  });
  return userService.post('ListParam/SaveListAdvancedQuery', data);
} // 通过表名获取原始表对应的字段信息集

export function GetIntiTableColumnList(query) {
  return userService.get('ListParam/GetIntiTableColumnList', {
    params: query
  });
}